import type { CampaignMessage } from "../../../../lib/types/schema/campaign/campaignMessageSchema";
import type { UseRequestMutationProps } from "../../../../request/hooks/useRequestMutation";
import { useRequestMutation } from "../../../../request/hooks/useRequestMutation";

type UseRequestCampaignMessageVariables = Pick<CampaignMessage, "text"> & {
  type: string;
};

export type UseRequestCampaignMessageProps = UseRequestMutationProps<
  any,
  UseRequestCampaignMessageVariables
> & {
  id: number;
};

export const useRequestCampaignMessage = ({
  id,
  ...props
}: UseRequestCampaignMessageProps) => ({
  mutationPost: useRequestMutation({
    ...props,
    mutationFnRequestProps: (data: UseRequestCampaignMessageVariables) => ({
      body: JSON.stringify(data),
      urlBackendPath: `/campaigns/${id}/message`,
    }),
  }),
});
